module.exports = __webpack_public_path__ + "img/to_sudoku_tc.73dda509.png";